import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, catchError, of } from 'rxjs';

/**
 * Auth Guard to protect routes that require authentication.
 * Checks if user has a valid session, redirects to login if not.
 */
export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // First check localStorage for existing auth
  const existingAuth = authService.getAuthFromLocalStorage();
  if (existingAuth) {
    // Verify the token has not expired
    const exp = existingAuth.payload?.exp;
    const now = Math.floor(Date.now() / 1000);
    if (typeof exp === 'number' && exp <= now) {
      console.log('Auth guard: Token expired, clearing session and redirecting to login');
      authService.logout();
      router.navigate(['/auth/login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    }
    console.log('Auth guard: Found valid auth in localStorage');
    return true;
  }

  console.log('Auth guard: No auth found, checking session...');
  
  return authService.getUserBySession().pipe(
    map((session) => {
      if (session) {
        console.log('Auth guard: Valid session found');
        return true;
      } else {
        console.log('Auth guard: No valid session, redirecting to login');
        // No valid session, redirect to login
        router.navigate(['/auth/login'], {
          queryParams: { returnUrl: state.url }
        });
        return false;
      }
    }),
    catchError((error) => {
      console.error('Auth guard: Error checking session', error);
      // Error fetching session, redirect to login
      router.navigate(['/auth/login'], {
        queryParams: { returnUrl: state.url }
      });
      return of(false);
    })
  );
};
